import React, { useState, useEffect } from 'react';
import { getCsrfHeader } from './csrf';

function AccountForm({ mode }) {
  const isEdit = mode === 'edit';

  const [username, setUsername] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isEdit) {
      fetch('/account')
        .then((res) => res.json())
        .then((data) => setUsername(data.username || ''))
        .catch(() => {});
    }
  }, [isEdit]);

  function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setErrors([]);
    setSuccess(false);

    const url = isEdit ? '/account/password' : '/createAccount';
    const method = isEdit ? 'PUT' : 'POST';
    const body = isEdit
      ? { oldpassword: oldPassword, password, confirmPassword }
      : { username, password, confirmPassword };

    fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json', ...getCsrfHeader() },
      body: JSON.stringify(body),
    })
      .then(async (response) => {
        if (response.ok) {
          setSuccess(true);
          setOldPassword('');
          setPassword('');
          setConfirmPassword('');
        } else {
          const data = await response.json().catch(() => ({}));
          setErrors(
            data.errors && data.errors.length
              ? data.errors
              : ['Something went wrong. Please try again.']
          );
        }
      })
      .catch(() => setErrors(['Something went wrong. Please try again.']))
      .finally(() => setSubmitting(false));
  }

  return (
    <div className="container">
      <div className="top-bar">
        <span className="top-link-static">{isEdit ? 'Edit Account' : 'Create Account'}</span>
        <a href={isEdit ? '/' : '/login'} className="top-link">
          {isEdit ? 'Back to Transactions' : 'Back to Log In'}
        </a>
      </div>

      <div className="account-box">
        <img src="/images/puppy.svg" alt="A cute puppy" className="puppy-img" />

        {errors.length > 0 && (
          <div className="account-errors">
            <p>{isEdit ? 'The password update failed.' : 'The account creation request failed.'}</p>
            <ul>
              {errors.map((message, index) => (
                <li key={index}>{message}</li>
              ))}
            </ul>
          </div>
        )}

        {success && (
          <p className="account-success">
            {isEdit ? (
              'Your password was updated successfully.'
            ) : (
              <>Your account was successfully created. You may <a href="/login">log in</a> now.</>
            )}
          </p>
        )}

        <form onSubmit={handleSubmit} className="account-form">
          <label htmlFor="username">Username</label>
          <input
            id="username"
            name="username"
            type="text"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            disabled={isEdit}
            required={!isEdit}
          />

          {isEdit && (
            <>
              <label htmlFor="oldPassword">Current Password</label>
              <input
                id="oldPassword"
                name="oldPassword"
                type="password"
                value={oldPassword}
                onChange={(event) => setOldPassword(event.target.value)}
                required
              />
            </>
          )}

          <label htmlFor="password">{isEdit ? 'New Password' : 'Password'}</label>
          <input
            id="password"
            name="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />

          <label htmlFor="confirmPassword">Confirm Password</label>
          <input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            required
          />

          <p className="account-hint">
            Your password must match your Wesbanco online banking password, or the nightly
            transaction sync won't be able to log in.
          </p>

          <button type="submit" disabled={submitting}>
            {isEdit ? 'Update Password' : 'Create Account'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AccountForm;
